import React from 'react';

const CustomerDetailView = ({ customer, onClose }) => {
    if (!customer) return null;

    // Image URL base path (Backend server address)
    const imgBase = "http://localhost:5000/";

    return (
        <div style={styles.overlay} onClick={onClose}>
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div style={styles.header}>
                    <div>
                        <h2 style={{ margin: 0 }}>{customer.full_name}</h2>
                        <span style={styles.refBadge}>File # {customer.ref_no || 'N/A'}</span>
                    </div>
                    <button onClick={onClose} style={styles.closeBtn}>&times;</button>
                </div>

                <div style={styles.scrollableContent}>
                    {/* Section 1: Personal & Reference Info */}
                    <div style={styles.section}>
                        <h4 style={styles.sectionTitle}>👤 Personal & Reference Information</h4>
                        <div style={styles.grid}>
                            <InfoBox label="Father Name" value={customer.father_name} />
                            <InfoBox label="CNIC" value={customer.cnic} />
                            <InfoBox label="Phone" value={customer.phone} />
                            <InfoBox label="City" value={customer.city_name} />
                            <InfoBox label="Occupation" value={customer.occupation} />
                            <InfoBox label="Monthly Income" value={`Rs. ${Number(customer.monthly_income).toLocaleString()}`} />
                            <InfoBox label="Reference Name" value={customer.ref_name} />
                            <InfoBox label="Reference Code" value={customer.ref_code} />
                            <div style={{ gridColumn: 'span 2' }}>
                                <InfoBox label="Full Address" value={customer.address} />
                            </div>
                        </div>
                    </div>

                    {/* Section 2: ID Card Images */}
                    <div style={styles.section}>
                        <h4 style={styles.sectionTitle}>🪪 ID Card Documents</h4>
                        <div style={styles.imageContainer}>
                            <div style={styles.imageWrapper}>
                                <p style={styles.imgLabel}>Front Side</p>
                                {customer.cnic_front ? (
                                    <img src={`${imgBase}${customer.cnic_front}`} alt="CNIC Front" style={styles.cnicImg} />
                                ) : <div style={styles.noImg}>No Front Image</div>}
                            </div>
                            <div style={styles.imageWrapper}>
                                <p style={styles.imgLabel}>Back Side</p>
                                {customer.cnic_back ? (
                                    <img src={`${imgBase}${customer.cnic_back}`} alt="CNIC Back" style={styles.cnicImg} />
                                ) : <div style={styles.noImg}>No Back Image</div>}
                            </div>
                        </div>
                    </div>

                    {/* Section 3: Guarantors */}
                    <div style={styles.guarantorGrid}>
                        {/* G1 */}
                        <div style={styles.gBox}>
                            <h4 style={{...styles.sectionTitle, color: '#059669'}}>🛡️ Guarantor 1</h4>
                            <div style={styles.gDetails}>
                                <p><strong>Name:</strong> {customer.g1_name || 'N/A'}</p>
                                <p><strong>Father:</strong> {customer.g1_father || 'N/A'}</p>
                                <p><strong>CNIC:</strong> {customer.g1_cnic || 'N/A'}</p>
                                <p><strong>Phone:</strong> {customer.g1_phone || 'N/A'}</p>
                                <p><strong>Job:</strong> {customer.g1_occupation || 'N/A'}</p>
                                <p><strong>Address:</strong> {customer.g1_address || 'N/A'}</p>
                            </div>
                        </div>

                        {/* G2 */}
                        <div style={styles.gBox}>
                            <h4 style={{...styles.sectionTitle, color: '#059669'}}>🛡️ Guarantor 2</h4>
                            <div style={styles.gDetails}>
                                <p><strong>Name:</strong> {customer.g2_name || 'N/A'}</p>
                                <p><strong>Father:</strong> {customer.g2_father || 'N/A'}</p>
                                <p><strong>CNIC:</strong> {customer.g2_cnic || 'N/A'}</p>
                                <p><strong>Phone:</strong> {customer.g2_phone || 'N/A'}</p>
                                <p><strong>Job:</strong> {customer.g2_occupation || 'N/A'}</p>
                                <p><strong>Address:</strong> {customer.g2_address || 'N/A'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Chota component label/value pair dikhane ke liye
const InfoBox = ({ label, value }) => (
    <div style={{ marginBottom: '10px' }}>
        <label style={{ fontSize: '12px', color: '#64748b', display: 'block' }}>{label}</label>
        <span style={{ fontSize: '14px', fontWeight: '500', color: '#1e293b' }}>{value || '---'}</span>
    </div>
);

const styles = {
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 },
    modal: { background: '#fff', width: '90%', maxWidth: '900px', borderRadius: '15px', overflow: 'hidden', maxHeight: '95vh', display: 'flex', flexDirection: 'column' },
    header: { padding: '20px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8fafc' },
    refBadge: { background: '#3b82f6', color: '#fff', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', marginTop: '5px', display: 'inline-block' },
    closeBtn: { border: 'none', background: 'none', fontSize: '28px', cursor: 'pointer', color: '#64748b' },
    scrollableContent: { padding: '25px', overflowY: 'auto' },
    section: { marginBottom: '30px', paddingBottom: '15px', borderBottom: '1px solid #f1f5f9' },
    sectionTitle: { margin: '0 0 15px 0', fontSize: '16px', color: '#2563eb', borderLeft: '4px solid', paddingLeft: '10px' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px' },
    imageContainer: { display: 'flex', gap: '20px', marginTop: '10px' },
    imageWrapper: { flex: 1, textAlign: 'center', background: '#f8fafc', padding: '10px', borderRadius: '10px', border: '1px dashed #cbd5e1' },
    imgLabel: { fontSize: '12px', marginBottom: '8px', color: '#64748b' },
    cnicImg: { width: '100%', height: '200px', objectFit: 'contain', borderRadius: '8px' },
    noImg: { height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: '13px' },
    guarantorGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' },
    gBox: { background: '#f0fdf4', padding: '20px', borderRadius: '12px', border: '1px solid #dcfce7' },
    gDetails: { fontSize: '13px', lineHeight: '1.8' }
};

export default CustomerDetailView;